import React, { useState, useEffect } from 'react'
import { Image, FormControl, Form } from 'react-bootstrap';
import { useStateValue } from '../../../utilities/StateProvider';
import { api } from '../../../utilities/fetch';

export default function Product(props) {

    const [image, setImage] = useState("");
    const [quantity, setQuantity] = useState(0);
    const [{ cart, isInterior }, dispatch] = useStateValue();
    const item = cart[props.data.slug];

    useEffect(() => {
        const getData = async (mediaId) => {
            const imgDetails = await api.get(`media/${mediaId}`);
            setImage(imgDetails.data.source_url);
            !!item && setQuantity(item.quantity);
        }
        getData(props.data.featured_media);
    }, []);

    useEffect(() => {
        !item && setQuantity(0);
    }, [item])

    const handleChangeQuantity = (e) => {
        const newQuantity = e.currentTarget.value;
        setQuantity((!!props.data.meta.max && Number(newQuantity) > Number(props.data.meta.max)) ? props.data.meta.max : newQuantity);

        const groupCart = {
            ...props.groupCart,
            [props.data.slug]: {
                quantity: (!!props.data.meta.max && Number(newQuantity) > Number(props.data.meta.max)) ? props.data.meta.max : newQuantity,
                price: props.data.meta.price,
                priceInterior: props.data.meta.price_interior,
                name: props.data.title.rendered,
                type: props.type,
                category: props.category.slug,
                categoryName: props.category.name,
                image
            }
        }

        props.setCart(groupCart);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;

        const newCart = {
            ...cart,
            [props.data.slug]: {
                quantity: form.quantity.value,
                price: !isInterior ? props.data.meta.price : props.data.meta.price_interior,
                name: props.data.title.rendered,
                type: props.type,
                image
            }
        }

        sessionStorage.setItem('cart', JSON.stringify(newCart));

        dispatch({
            type: 'setCart',
            cart: newCart
        });
    }

    return (
        <Form onSubmit={handleSubmit}>
            <Image src={image} className={(props.type === 'products') ? 'products' : 'extras'} fluid />
            <div className="product-name">{props.data.title.rendered}</div>
            <FormControl
                className="quantity"
                name="quantity"
                size="sm"
                placeholder="Cantidad"
                pattern="[1-9]\d*"
                value={quantity}
                title="Solo puede agregar numeros mayores a 0"
                onChange={handleChangeQuantity}
                disabled={!Number(props.data.meta.available)}
            />
            <div className="price">{`$${!isInterior ? props.data.meta.price : props.data.meta.price_interior}`}</div>
        </Form>
    )
}
